










import { Component, Vue } from "vue-property-decorator"
import GameScreen from "./components/GameScreen.vue"

@Component({
  components: {
    GameScreen
  }
})
export default class App extends Vue {
  protected money() {
    this.$store.dispatch("editMoney", 100)
  }

  protected pausetog() {
    if (!this.$store.getters.event) {
      if (this.$store.state.paused) {
        this.$store.dispatch("unpause")
      } else {
        this.$store.dispatch("pause")
      }
      if (!this.$store.state.muted) {
        new Howl({
          src: ["/audio/Click.mp3"]
        }).play()
      }
    }
  }

  protected skip() {
    if (this.$store.state.roundActive) {
      this.$store.dispatch("nullTimer")
    }
  }
}
